import { useRef } from 'react'
import {
  useDispatch,
  useSelector
} from 'react-redux'

import {
  selectAuthToken,
} from '../redux/features/user/userSlice'

import {
  Link as RouterLink
} from 'react-router-dom'

import { 
  Box, 
  Link 
} from '@mui/material'

import {
  clearFlashAlert,
  clearFlashNotice,
  setFlashAlert,
  setFlashNotice,
} from '../redux/features/ui/uiSlice'

const classes = {
  box: {
    display: 'flex',
    alignSelf: 'flex-start',
    marginTop: '8px',
    fontSize: 14,
  },
  hiddenForm: {
    display: 'none',
  },
  link: {
    margin: '0 5px 0 5px',
    cursor: 'pointer',
  },
}

export default function UnauthenticatedNavigation(props) {
  const authToken = useSelector(selectAuthToken) || ''
  const dispatch = useDispatch()

  const handleClick = (e) => {
    dispatch(clearFlashNotice())
    dispatch(clearFlashAlert())
  }

  return (
    <Box 
      component='span' 
      sx={{ ...classes.box, ...classes.topRightBox }}
    >
      <Link 
        component={RouterLink}
        onClick={handleClick}
        to='/app/sign_in'
        sx={classes.link}
        rel='nofollow'
        color='inherit'
      >
        Sign In
      </Link>
      <Link 
        component={RouterLink}
        onClick={handleClick}
        to='/app/sign_up'
        sx={classes.link}
        color='inherit'
      >
        Sign Up
      </Link>
      <Link
        component={RouterLink}
        onClick={handleClick}
        to='/help'
        sx={classes.link}
        color='inherit'
      >
        Help
      </Link>
    </Box>
  )
}